module.exports = __webpack_public_path__ + "img/seguros_reyva.31f97194.png";